const pageNameKey = "applyMyBlueprintLibrary";

export const applyMyBlueprintLibraryEn = {
  [pageNameKey]: {
    subTitle: "Apply selected Blueprint",
    title: "Replace your current structure",
    description:
      "All changes in your current structure will be replaced by the following Blueprint structure:",
    descriptionTitle: "Description",
    replaceButton: "Replace Structure",
    cancelButton: "Cancel",
  },
};

export const applyMyBlueprintLibraryPtBr = {
  [pageNameKey]: {
    subTitle: "Aplicar Blueprint selecionado",
    title: "Substitua sua estrutura atual",
    description:
      "Todas as alterações na sua estrutura atual serão substituídas pela seguinte estrutura do Blueprint:",
    descriptionTitle: "Descrição",
    replaceButton: "Substituir estrutura",
    cancelButton: "Cancelar",
  },
};

export const applyMyBlueprintLibraryDe = {
  [pageNameKey]: {
    subTitle: "Ausgewählten Blueprint anwenden",
    title: "Aktuelle Struktur ersetzen",
    description:
      "Alle Änderungen in Ihrer aktuellen Struktur werden durch die folgende Blueprint-Struktur ersetzt:",
    descriptionTitle: "Beschreibung",
    replaceButton: "Struktur ersetzen",
    cancelButton: "Abbrechen",
  },
};

export const applyMyBlueprintLibraryZhHans = {
  [pageNameKey]: {
    subTitle: "应用选定的蓝图",
    title: "替换当前结构",
    description: "您当前结构中的所有更改将被以下蓝图结构替换：",
    descriptionTitle: "描述",
    replaceButton: "替换结构",
    cancelButton: "取消",
  },
};

export const applyMyBlueprintLibraryIt = {
  [pageNameKey]: {
    subTitle: "Applica il Blueprint selezionato",
    title: "Sostituisci la tua struttura attuale",
    description:
      "Tutte le modifiche alla struttura attuale verranno sostituite dalla seguente struttura del Blueprint:",
    descriptionTitle: "Descrizione",
    replaceButton: "Sostituisci Blueprint",
    cancelButton: "Annulla",
  },
};

export const applyMyBlueprintLibraryEs = {
  [pageNameKey]: {
    subTitle: "Aplicar Blueprint seleccionado",
    title: "Reemplaza tu estructura actual",
    description:
      "Todos los cambios en tu estructura actual serán reemplazados por la siguiente estructura del Blueprint:",
    descriptionTitle: "Descripción",
    replaceButton: "Reemplazar estructura",
    cancelButton: "Cancelar",
  },
};

export const applyMyBlueprintLibraryNl = {
  [pageNameKey]: {
    cancelButton: "Annuleren",
    description:
      "Alle wijzigingen in uw huidige structuur worden vervangen door de volgende blueprint-structuur:",
    descriptionTitle: "Beschrijving",
    replaceButton: "Structuur vervangen",
    subTitle: "Geselecteerde blueprint toepassen",
    title: "Huidige structuur vervangen",
  },
};

export const applyMyBlueprintLibraryTr = {
  [pageNameKey]: {
    cancelButton: "İptal etmek",
    description:
      "Mevcut yapınızdaki tüm değişikliklerin yerini aşağıdaki Blueprint yapısı alacaktır:",
    descriptionTitle: "Tanım",
    replaceButton: "Yapıyı Değiştir",
    subTitle: "Seçilen Planı uygula",
    title: "Mevcut yapınızı değiştirin",
  },
};
